import React, { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';
type TimeLeft = {
  hours: number;
  minutes: number;
  seconds: number;
};
function calculateTimeLeft(): TimeLeft {
  const now = new Date();
  const midnight = new Date();
  midnight.setHours(24, 0, 0, 0);
  const diff = midnight.getTime() - now.getTime();
  return {
    hours: Math.floor(diff / (1000 * 60 * 60) % 24),
    minutes: Math.floor(diff / (1000 * 60) % 60),
    seconds: Math.floor(diff / 1000 % 60)
  };
}
export function OfferCountdown() {
  const [timeLeft, setTimeLeft] = useState<TimeLeft>(calculateTimeLeft());
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatNumber = (num: number) => num.toString().padStart(2, '0');
  return <div className="bg-gradient-to-r from-red-600 to-red-700 text-white px-6 py-4 rounded-2xl shadow-lg mb-6" data-id="element-1101">
      <div className="flex flex-col sm:flex-row items-center justify-center gap-3" data-id="element-1102">
        <div className="flex items-center gap-2" data-id="element-1103">
          <Clock className="w-5 h-5 animate-pulse" data-id="element-1104" />
          <span className="font-bold text-sm uppercase tracking-wide" data-id="element-1105">
            La oferta termina en:
          </span>
        </div>

        <div className="flex items-center gap-1" data-id="element-1106">
          {/* Hours */}
          <div className="bg-white/20 backdrop-blur-sm rounded-lg px-3 py-2 min-w-[60px] text-center" data-id="element-1107">
            <span className="text-2xl sm:text-3xl font-black tabular-nums" data-id="element-1108">
              {formatNumber(timeLeft.hours)}
            </span>
            <span className="block text-[10px] uppercase tracking-wider opacity-80" data-id="element-1109">
              Horas
            </span>
          </div>

          <span className="text-2xl font-bold animate-pulse" data-id="element-1110">:</span>

          {/* Minutes */}
          <div className="bg-white/20 backdrop-blur-sm rounded-lg px-3 py-2 min-w-[60px] text-center" data-id="element-1111">
            <span className="text-2xl sm:text-3xl font-black tabular-nums" data-id="element-1112">
              {formatNumber(timeLeft.minutes)}
            </span>
            <span className="block text-[10px] uppercase tracking-wider opacity-80" data-id="element-1113">
              Min
            </span>
          </div>

          <span className="text-2xl font-bold animate-pulse" data-id="element-1114">:</span>

          {/* Seconds */}
          <div className="bg-white/20 backdrop-blur-sm rounded-lg px-3 py-2 min-w-[60px] text-center" data-id="element-1115">
            <span className="text-2xl sm:text-3xl font-black tabular-nums" data-id="element-1116">
              {formatNumber(timeLeft.seconds)}
            </span>
            <span className="block text-[10px] uppercase tracking-wider opacity-80" data-id="element-1117">
              Seg
            </span>
          </div>
        </div>
      </div>
    </div>;
}